//
//
//
//
//
//
//
//
//
//
//
//

import login from './components/home/login.vue';
import notAvailable from './components/home/notAvailable.vue';
import customWebSocket from './components/common/customWebSocket.js';
import messageParsingJS from './components/customerService/messageParsing.js';
import wechatJS from './components/common/wechat.js';
import notificationBox from './components/customerService/notification.vue';

export default {
    mixins: [customWebSocket, messageParsingJS, wechatJS],
    name: 'App',
    components: {
        login,
        notAvailable,
        notificationBox
    },
    data() {
        return {
            carBadge: 0,
            loginFlag: true,
            defaultPoster: './static/images/default_handsome.jpg'
        };
    },
    computed: {
        token() {
            return this.$store.state.token;
        },
        userInfo() {
            return this.$store.state.userInfo;
        },
        routerKeepAlive() {
            var keepAliveVal = false;
            if (this.$route.meta && this.$route.meta.keepAlive) {
                keepAliveVal = true;
            }
            return keepAliveVal;
        }
    },
    watch: {
        token(newVal) {
            if (newVal) {
                sessionStorage.token = newVal;
                //初始化websocket(客服聊天)
                this.initWebSocket();
            } else {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('shoppingCartList');
                this.$store.state.carBadge = 0;
            }
        },
        userInfo: {
            handler(newVal) {
                sessionStorage.userInfo = JSON.stringify(newVal);
            },
            deep: true
        },
        $route(to, from) {
            if (this.$isPc() && to.path == '/mallGoods' && to.query.code) {
                this.weixinLogin();
            }
        }
    },
    methods: {
        getOrderCartNum() {
            let that = this;
            that.$axios
                .get('/api/v1.0/lonbonShop/orderCartNum', {
                    params: {
                        shopperId: that.$store.state.userInfo.shopperId
                    }
                })
                .then(function (response) {
                    if (response.status == 200) {
                        that.$store.state.carBadge = response.body + '';
                    }
                });
        },
        //获取用户信息
        getUserInfo(accountType) {
            let that = this;
            that.$axios
                .get('/api/v1.0/lonbonShop/userInfo', {
                    params: {
                        accountType: accountType
                    }
                })
                .then(function (response) {
                    if (response.status == 200) {
                        var user = response.body;
                        var userInfo = {
                            poster: that.dealHeadImage(user.headImage),
                            displayName: user.displayName,
                            shopperId: user.shopperId,
                            accountId: user.accountId
                        };
                        //微信小程序授权获得的信息
                        if (sessionStorage.weixinAppInfo) {
                            var weixinAppInfo = JSON.parse(sessionStorage.weixinAppInfo);
                            userInfo.poster = userInfo.poster != that.defaultPoster ? userInfo.poster : weixinAppInfo.avatarUrl;
                            userInfo.displayName = userInfo.displayName ? userInfo.displayName : weixinAppInfo.nickName;
                        }
                        that.$store.state.userInfo = userInfo;
                    }
                });
        },
        //子女App中登录：获取url中是否存在token；
        getUrlToken() {
            var params = this.$queryUrlParams(window.location.href);
            if (params && params.token) {
                this.$store.state.token = params.token;
                sessionStorage.fromLBApp = true;
            } else {
                sessionStorage.fromLBApp = false;
            }
            this.getUserInfo(1);
        },
        //微信内登录：跳转登录页逻辑
        toLoginFunc() {
            if (this.loginFlag) {
                this.loginFlag = false;
                setTimeout(() => {
                    this.loginFlag = true;
                }, 1500);
            } else {
                return false;
            }
            if (this.$isWeixin()) {
                var redirect_uri = encodeURIComponent(sessionStorage.domainURL + '/LonBonStore');
                // var redirect_uri = encodeURIComponent('http://192.168.8.214:8899');
                sessionStorage.wxRedirectPath = this.$route.fullPath;
                if (this.$isWeixinApp()) {
                    this.$wechat.miniProgram.navigateTo({ url: '/pages/login/login?redirectUrl=' + redirect_uri });
                } else {
                    this.getWeiXinConfig(function (weiXinConfig) {
                        var url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${weiXinConfig.appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=STATE&connect_redirect=1#wechat_redirect`;
                        window.location.href = url;
                    }, '');
                }
            } else {
                if (this.$isPc()) {
                    sessionStorage.wxRedirectPath = this.$route.fullPath;
                    this.$store.state.pcLoginShow = true;
                } else { // 非来邦养老app、pc以及微信浏览器
                    // this.$store.state.loginShow = true; 
                    this.$refs.notAvailableRef.getFromLBApp()
                    this.$store.state.notAvailable = true
                }
            }
            // this.$store.state.loginShow = true;
        },
        //微信授权登录后的回调处理
        weixinLogin() {
            let that = this;
            if (that.$store.state.token) {
                this.getUserInfo(10);
            } else {
                var params = that.$queryUrlParams(window.location.href);
                if (params && params.code) {
                    // console.log('微信授权登录后的回调处理' + params.code);
                    let type;
                    if (that.$isWeixinApp()) {
                        type = 'APPLETS';
                    } else if (that.$isPc()) {
                        type = 'WEB';
                    } else {
                        type = 'WX';
                    }
                    that.$axios
                        .get('/api/v1.0/weChatLogin', {
                            params: {
                                code: that.$trim.all(params.code),
                                type: type
                            }
                        })
                        .then(function (response) {
                            // console.log(response);
                            if (response.status == 200) {
                                that.$store.state.token = response.body;
                                if (that.$isWeixinApp()) {
                                    sessionStorage.weixinAppInfo = JSON.stringify({
                                        avatarUrl: decodeURIComponent(params.avatarUrl),
                                        nickName: params.nickName
                                    });
                                }
                                if (that.$isPc()) {
                                    that.$store.state.pcLoginShow = false;
                                }
                                that.getUserInfo(10);
                                if (sessionStorage.wxRedirectPath) {
                                    that.$router.push(sessionStorage.wxRedirectPath);
                                }
                            }
                        });
                }
            }

            //微信环境初始化
            let currentUrl = location.href.split('#')[0];
            that.getWeiXinConfig(function (weiXinConfig) {
                that.wechatInit(weiXinConfig);
            }, currentUrl);
        },
        //处理头像
        dealHeadImage(headImage) {
            var url = this.defaultPoster;
            if (headImage) {
                if (headImage.indexOf('http://') > -1 || headImage.indexOf('https://') > -1) {
                    url = headImage;
                } else {
                    url = this.$formatFile(headImage);
                }
            }
            return url;
        },
        //获取微信配置
        getWeiXinConfig(callback, url_) {
            let that = this;
            that.$axios
                .get('/api/v1.0/weChatPublicSignature', {
                    params: {
                        url: url_
                    }
                })
                .then(function (response) {
                    if (response.status == 200) {
                        var weiXinConfig = response.body;
                        callback && callback(weiXinConfig);
                    }
                });
        },
        blurFun() {
            setTimeout(() => {
                window.scrollTo(0, document.body.scrollTop + 1);
                document.body.scrollTop >= 1 && window.scrollTo(0, document.body.scrollTop - 1);
                // console.log('键盘收起' + document.body.clientHeight);
            }, 100);
        }
    },
    mounted() {
        // console.log('currentURL:' + location.href);
        this.$store.state.token = sessionStorage.token;
        if (sessionStorage.token && sessionStorage.userInfo) {
            this.$store.state.userInfo = JSON.parse(sessionStorage.userInfo);
        }
        if (!this.$isPc()) {
            if (this.$isWeixin()) {
                this.weixinLogin();
            } else {
                this.getUrlToken();
            }
        }
        this.$store.state.APPPAGE = this;
    }
};



// WEBPACK FOOTER //
// ./src/App.vue